namespace $.$$ {

	$mol_style_define( $shm_hitalama_attach, {

	} )

}
